var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-app',[_c('v-app-bar',{attrs:{"app":"","color":"primary","dark":""}},[_c('v-toolbar-title',[_c('span',{staticClass:"headline"},[_vm._v("Metamask Login Flow")])])],1),_c('v-main',[_c('LoginFlow')],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }